<template>
	<div id="page-content" class="supplier-sidebar">
	
		<div class="component-padding">
		
			<h1 style="display: inline-block;">Product Information</h1>
			<p>Fill up all necessary information</p>
			<form id="proposeitem" method="POST" action="">
				
				<div class="col-md-4">
					<label for="code">Product Code</label>
					<input type="text" name="code" id="code"/>
					
					<label for="description">Product Description</label>
					<textarea name="description" id="description"></textarea>
					
					<label for="no_of_sockets">No. of Sockets</label>
					<input type="text" name="no_of_sockets" id="no_of_sockets"/>
				</div>
				
				<div class="col-md-4">
					<label for="package_dimensions">Package Dimension</label>
					<input type="text" name="package_dimensions" id="package_dimensions" placeholder="L x W x H"/>
					
					<label for="item_dimensions">Item Dimension</label>
					<input type="text" name="item_dimensions" id="item_dimensions" placeholder="L x W x H"/>
					
					<label for="min_order">Minimum order quantity</label>
					<input type="text" name="min_order" id="min_order"/>
				</div>
				
				<div class="col-md-4">
					<label for="price">Price</label>
					<input type="text" name="price" id="price"/>
					
					<label for="pricing">Pricing</label>
					<select name="pricing" id="pricing">
						<option value="">FOB</option>
						<option value="">CIF</option>
						<option value="">CNF</option>
					</select>
					
					<label for="currency">Currency</label>
					<select name="currency" id="currency">
						<option value="">Php</option>
						<option value="">Usd</option>
						<option value="">jpy</option>
					</select>
				</div>
				
				<div style="clear: both;"></div>
				<h1 style="margin-top: 40px;">Product Specifications</h1>
				<p>Check all items that apply</p>
				
				<!-- this is gonna hurt a little -->
				<div class="col-xs-12">
					<h2 style="margin-bottom: 40px;">Design</h2>
					<div>
						<label class="spec col-md-4 col-xs-12" for="check1" ><input type="checkbox" name="check[]" id="check1" value="val1"/> <span>Classic</span><div></div></label>
						<label class="spec col-md-4 col-xs-12" for="check2" ><input type="checkbox" name="check[]" id="check2" value="val2"/> <span>Contemporary</span><div></div></label>
						<label class="spec col-md-4 col-xs-12" for="check3" ><input type="checkbox" name="check[]" id="check3" value="val3"/> <span>Modern</span><div></div></label>
					</div>
				</div>
				
				<div class="col-xs-12">
					<h2 style="margin-bottom: 40px;">Materials</h2>
					<div>
						<label class="spec col-md-4 col-xs-12" for="check4" ><input type="checkbox" name="check[]" id="check4" value="val4"/> <span>Acrylic</span><div></div></label>
						<label class="spec col-md-4 col-xs-12" for="check5" ><input type="checkbox" name="check[]" id="check5" value="val5"/> <span>Crystal</span><div></div></label>
						<label class="spec col-md-4 col-xs-12" for="check6" ><input type="checkbox" name="check[]" id="check6" value="val6"/> <span>Plastic</span><div></div></label>
						<label class="spec col-md-4 col-xs-12" for="check7" ><input type="checkbox" name="check[]" id="check7" value="val7"/> <span>Aluminum</span><div></div></label>
						<label class="spec col-md-4 col-xs-12" for="check8" ><input type="checkbox" name="check[]" id="check8" value="val8"/> <span>Glass</span><div></div></label>
						<label class="spec col-md-4 col-xs-12" for="check9" ><input type="checkbox" name="check[]" id="check9" value="val9"/> <span>Wood</span><div></div></label>
					</div>
				</div>
				
				<div class="col-xs-12">
					<h2 style="margin-bottom: 40px;">Add other items here later</h2>
				</div>
				
				<div class="pull-right" style="padding: 0 15px; margin-top: 40px;">
					<button class="button-type-e">Propose Item</button>
				</div>
				
				<div style="clear: both; margin-bottom: 40px;"></div>
				
			</form>
		</div>
		
	</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// SupplierProductProposal.vue?0ff3af69